export default "__VITE_ASSET__XJ9LwgTI__";